export default __webpack_public_path__ + "bbc2f926d84382f2fbed9ba9a388e941.png";